import React, { Fragment, useEffect, useState } from 'react'
import { Button, Container, Row, Col, Form, Card} from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'
import { serviceGetDetalles, serviceGetInforme, serviceGetResponsablesAsignados } from '../../api/api-descarga-movimientos';
import { Auth } from 'recupero-comunes';

const DescargaMovimientos = () => {
    const [loading, setLoading] = useState(false);

    const [tipoMovimientos, setTipoMovimientos] = useState([]);
    const [priorizarMovimientos, setPriorizarMovimientos] = useState([]);
    const [responsablesAsignados, setResponsablesAsignados] = useState([]);

    const [stateTipoMovimiento, setStateTipoMovimiento] = useState("");
    const [statePriorizarMovimiento, setStatePriorizarMovimiento] = useState("");
    const [stateResponsableAsignado, setStateResponsableAsignado] = useState("");

    useEffect(() => {
        getTipoMovimientos(); 
        getResponsablesAsignados();
    }, [])

    useEffect(() => {
        if (stateTipoMovimiento === "") setStatePriorizarMovimiento("");
        if (Number(stateTipoMovimiento) === 273001 && priorizarMovimientos?.length === 0) getPriorizarMovimientos();
    }, [stateTipoMovimiento])

    const getTipoMovimientos = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 273 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setTipoMovimientos(response);
    }

    const getPriorizarMovimientos = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 263 })).toString('base64');
        const response = await serviceGetDetalles(query);

        setPriorizarMovimientos(response);
    }

    const getResponsablesAsignados = async () => {
        const query = Buffer.from(JSON.stringify({ idOrganizacion: Auth.currentUser().rutOrganizacion, rol: "0070ABOEXT", tipoPersona: "0080PROVE00" })).toString('base64');
        const response = await serviceGetResponsablesAsignados(query);

        setResponsablesAsignados(response);
    }

    const handleClear = () => {
        setStateTipoMovimiento("");
        setStatePriorizarMovimiento("");
        setStateResponsableAsignado("");
    }

    const handleInforme = async () => {
        setLoading(true);
        let objeto = {
            tipoMov: stateTipoMovimiento,
            opcPriorizar: statePriorizarMovimiento,
            idResponsable: stateResponsableAsignado,
            idUsuario: Auth.currentUser().rutUsuario
        }

        if (Number(stateTipoMovimiento) !== 273001) delete objeto.opcPriorizar
        const query = Buffer.from(JSON.stringify(objeto)).toString('base64');

        const response = await serviceGetInforme(query);
        setLoading(false);

        var link = document.createElement("a");
        link.download = response.file.filename;
        link.href = "data:" + "application/vnd.ms-excel" + ";base64," + response.file.xlsxfile;
        link.click();
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Container className='mt-4'>
            <Card className='mt-2'>
                <Container>
                    <span style={{ fontSize: '22px', fontWeight: '600', color: '#666' }}>Descarga Movimientos por Actualizar</span>
                </Container>
                <br></br>     
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >Selección Descarga de Movimientos</Card.Header>
                <Container style={{ padding: '20px 30px' }}>
                    <Row>
                        <Col md='4'>
                            <Form.Label className="label is_required">Tipo Movimiento</Form.Label>
                            <br />
                            <Form.Select
                                name='codMonedaIngreso'
                                value={stateTipoMovimiento}
                                onChange={(e) => setStateTipoMovimiento(e.target.value)}>

                                <option value={''}>Seleccione...</option>
                                {tipoMovimientos && tipoMovimientos
                                    .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                }
                            </Form.Select>
                        </Col>

                        <Col md='4'>
                            <Form.Label className="label">Priorizar Movimientos</Form.Label>
                            <br />
                            <Form.Select
                                disabled={Number(stateTipoMovimiento) !== 273001}
                                name='codMonedaIngreso'
                                value={statePriorizarMovimiento}
                                onChange={(e) => setStatePriorizarMovimiento(e.target.value)}>

                                <option value={''}>Seleccione...</option>
                                {priorizarMovimientos && priorizarMovimientos
                                    .filter(p => p.agrupacion === 261002)
                                    .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                }
                            </Form.Select>
                        </Col>
                        <Col md='4'>
                            <Form.Label className="label">Responsable Asiganado</Form.Label>
                            <br />
                            <Form.Select
                                name='codMonedaIngreso'
                                value={stateResponsableAsignado}
                                onChange={(e) => setStateResponsableAsignado(e.target.value)}>

                                <option value={''}>Seleccione...</option>
                                {responsablesAsignados && responsablesAsignados
                                    .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                }
                            </Form.Select>
                        </Col>
                    </Row>
                </Container>

                <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                <Container>
                    <Row>
                        <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                            <Button className='m-2 w-auto' variant='warning' onClick={handleClear}>
                                Limpiar
                            </Button>
                            <Button className='m-2 w-auto' variant='danger'
                                disabled={stateTipoMovimiento === ""}
                                onClick={handleInforme}>
                                Ver Informe
                            </Button>
                        </Col>
                    </Row>
                </Container>
                <hr style={{ borderTop: '2px solid #04005D' }}></hr>
            </Card>
            </Container>

            <style type='text/css'>
                {`
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
            `}
            </style>

        </Fragment >
    )
}

export default DescargaMovimientos